import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, mergeMap } from 'rxjs/operators';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/operators';
import { ConfigService } from 'src/app/common/services/config.service';
import { of, throwError } from 'rxjs';
import { CommonConstants } from '../common/utilities/commonConstants';
import { CookieHandlerService } from '../common/services/cookieHandler.service';
@Injectable({
  providedIn: 'root'
})
export class EpbitlyService {
  pan: any;
  mobileNumber: any;
  ntcSettings: { data: { mobileNumber: any; }};

  constructor(
    private _http: HttpClient,
    private _cookieHandler: CookieHandlerService
  ) { }

  private getHeaders = (): HttpHeaders => {
    const headerObj: HttpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      'authtoken': this._cookieHandler.GetCookie(CommonConstants.CookieKeysAA.authtoken),
    });
    return headerObj;
  }
  public consentAccount(data:any): Observable<any> {
    const options = {
      headers: this.getHeaders(),
      observe: 'response' as const,
    };
    const dataToSend = JSON.stringify(data);

    const url =
      ConfigService.getInstance().getConfigObject().APIURL.consentAccount;
   
    return this._http
      .post<any>(url, dataToSend, options)

      .pipe(
        map((res) => {
          return {
            payload: res.body,
            status: res.status,
            headers: res.headers,
          };
        }),
        catchError((error) => {
          const errorObj = {
            payload: error.error,
            status: error.status,
            headers: error.headers,
          };
          return of(errorObj);
        })
      );
  } 
  public sessionUIToken(data:any): Observable<any> {
    const options = {
      headers: this.getHeaders(),
      observe: 'response' as const,
    };
    const dataToSend = JSON.stringify(data);
    const url =
      ConfigService.getInstance().getConfigObject().APIURL.sessionUIToken + data.sessionId +'/'+'tokens';
    return this._http
      .post<any>(url,null,options)

      .pipe(
        map((res) => {
          return {
            payload: res.body,
            status: res.status,
            headers: res.headers,
          };
        }),
        catchError((error) => {
          const errorObj = {
            payload: error.error,
            status: error.status,
            headers: error.headers,
          };
          return of(errorObj);
        })
      );
  }

  public regExCheck = {
    isBase64 : /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/
  }
  public getUIToken(productCode:any): Observable<any> {
    const options = {
      headers: this.getHeaders(),
      observe: 'response' as const,
    };
    const data = {
      productCode: productCode,
    };
    const productCodeData = JSON.stringify(data);

    const url =
      ConfigService.getInstance().getConfigObject().APIURL.securedCookie;
    return this._http
      .post<any>(url, productCodeData, options)
      .pipe(
        map((res) => {
          this._cookieHandler.SetCookie(CommonConstants.CookieKeysAA.authtoken,res.headers.get(CommonConstants.CookieKeysAA.headerResAuth));
          return {
            payload: res.body,
            status: res.status,
            headers: res.headers,
          };
        }),
        catchError((error) => {
          const errorObj = {
            payload: error.error,
            status: error.status,
            headers: error.headers,
          };
          return of(errorObj);
        })
      );
  }

  public staticLinkFlow(productCode:any,mobileNumberPayload?:any,utmObj?:any): Observable<any> {
    return this.getUIToken(productCode).pipe(
    mergeMap((getUIToken: any) =>{
      const options = {
        headers: this.getHeaders(),
        observe: 'response' as const,
      };
      const dataToSend = JSON.stringify(mobileNumberPayload)
     return this._http
          .post<any>(ConfigService.getInstance().getConfigObject().APIURL.transaction, dataToSend, options) //create transaction flow
      .pipe(
         catchError(error => {
           const errorObj = {
             payload: error.error,
             status: error.status,
             headers: error.headers,
           };
           return throwError(errorObj); // return error that will trigger the subscriptions `error` block
         }))})
       ).pipe(
        mergeMap((GetTransaction: any) =>
       {              const options = {
                  headers: this.getHeaders(),
                  observe: 'response' as const,
                };
                const reqPayload = {
                  applicationKey:GetTransaction.body.transactionId,
                  source:'journey',
                  mobile:mobileNumberPayload.mobileNumber
                }
        return this._http
        .post<any>(ConfigService.getInstance().getConfigObject().APIURL.pcTokenUrl, reqPayload, options) //tokenApi api flow 
       .pipe(
          catchError(error => {
            const errorObj = {
              payload: error.error,
              status: error.status,
              headers: error.headers,
            };
            return throwError(errorObj); // return error that will trigger the subscriptions `error` block
          }))}
          )
        ).pipe(
          mergeMap((tokenApi: any) =>
         {
          if (tokenApi.status === 200 || tokenApi.status === 201 ) {
            this._cookieHandler.deleteCookie(CommonConstants.CookieKeysAA.authtoken);
            this._cookieHandler.SetCookie(CommonConstants.CookieKeysAA.authtoken, tokenApi.body.payload.tokens[0].token);  
          } 
          const options = {
            headers: this.getHeaders(),
            observe: 'response' as const,
          };
          // const dataToSend = JSON.stringify(mobileNumberPayload);
          const dataToSend = {
            mobile:mobileNumberPayload.mobileNumber,
            productCode : "AA_Campaign_Link"
          }
          return this._http
          .post<any>(ConfigService.getInstance().getConfigObject().APIURL.consentAccount, dataToSend, options)
      // consent account flow
          .pipe(catchError(error => {
            const errorObj = {
              payload: error.error,
              status: error.status,
              headers: error.headers,
            };
            return throwError(errorObj); // return error that will trigger the subscriptions `error` block
          }))
        }
        ))
    }
} 
